import React from 'react';
import ErrorComponent from '../ErrorComponent';

const PageNotFound = (props) => <ErrorComponent props={props} errorType="404" errorCode="404" />;

export default PageNotFound;
